import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {useParams} from "react-router-dom";

import appStore from "../../../../storage/AppStore";
import clubStore from "../../../../storage/ClubStore";

import CompanyUserForm from "./CompanyUserForm";


const STAFF_ROLES = [
    "MGR",
    "TRN",
    "MDC",
    "SMM",
];


const NewStaff = () => {

    const {
        roleId,
    } = useParams();


    const roleValid =
        STAFF_ROLES.includes(
            roleId
        );


    useEffect(() => {
        clubStore.resetMember();

        if (!roleValid) {
            return;
        }

        clubStore.member.setProperty(
            "role_id",
            roleId
        );
    }, [roleId, roleValid]);


    useEffect(() => {
        if (
            !clubStore.club.id ||
            clubStore.member.company_id
        ) {
            return;
        }

        clubStore.member.setProperty(
            "company_id",
            clubStore.club.id
        );
    }, [clubStore.club.id]);


    if (!roleValid) {
        return null;
    }


    const roleName =
        appStore.rolesLocalized.find(
            (role) =>
                role.id === roleId
        )?.name || roleId;


    return (
        <CompanyUserForm
            title={
                `${appStore.tr.add || "Добавить"}: ${roleName}`
            }
        />
    );
};


export default observer(
    NewStaff
);